import LoadingView from '@/views/LoadingView.vue';

const loadingRoutes = [
  {
    path: '/loading',
    name: 'loading',
    meta: {
      headerConfig: {
        headerLabel: 'loading',
        hide: false,
        showBack: false,
        showProfile: false,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: LoadingView,
  },
];

export default loadingRoutes;
